// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root__ub4Sb","frame":"Login_frame__JBOJW","config":"Login_config__WLA1g"};